import React from 'react';
import styled from '@emotion/styled';
import _, { isNumber } from 'lodash';

import { Flex, Box } from '../grid';
import StarRating from '../star-rating';
import { RATERS, SPACE, BREAKPOINTS } from '../../constants';
import { H4, ExtraSmall } from '../type';
import Tooltip from '../tooltip';
import { STAR_PLACEMENT } from '../star-rating/constants';

export const Row = styled.div`
  align-items: center;
  display: flex;
`;

export const TooltipWrapper = styled.div`
  display: inline-block;
  margin-left: ${SPACE.X0};

  @media (min-width: ${BREAKPOINTS.SM}px) {
    margin-left: 8px;
  }

  @media (min-width: ${BREAKPOINTS.LG}px) {
    margin-left: 12px;
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'label' implicitly has an 'any' type.
const SafetyRow = ({ label, feature, tooltip, starColor, maxStars, starAriaDescription }) => {
  if (_.isUndefined(feature) || _.isNull(feature)) return null;

  return (
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'className' is missing in type '{ children: any[]; mb: string; }' but required in type '{ [x: string]: any; children: any; className: any; }'.
    <Box mb={SPACE.X1}>
      {label && <ExtraSmall as="h4">{label}</ExtraSmall>}
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'className' is missing in type '{ children: any[]; alignItems: string; }' but required in type '{ [x: string]: any; children: any; className: any; }'. */}
      <Flex alignItems="center">
        {isNumber(feature) ? (
          <StarRating
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'number' is not assignable to type 'null | undefined'.
            stars={feature}
            // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string' is not assignable to type 'null | undefined'.
            ratingBy={RATERS.UCSR}
            placement={STAR_PLACEMENT.SAFETY_ROW}
            starColor={starColor}
            maxStars={maxStars}
            starAriaDescription={starAriaDescription}
          />
        ) : (
          <H4 as="span">{feature}</H4>
        )}
        {tooltip && (
          <TooltipWrapper>
            <Tooltip title={tooltip} />
          </TooltipWrapper>
        )}
      </Flex>
    </Box>
  );
};

export default SafetyRow;
